import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MioService extends BaseService {

  apiUrl = environment.apiUrlMio;

  constructor(protected http: HttpClient) { 
    super(http);
  }

  getRegions(): Observable<IMioRegion[]> {
    let url = 'Info/GetRegions';
    return this.get(this.apiUrl+url, {}, true);
  }

  getAllData(): Observable<IMioLivingComplex[]> {
    let url = 'LivingComplexes/GetAll';
    return this.get(this.apiUrl+url, {}, true);
  }

  getCities(regionId: number): Observable<IMioRegion[]> {
    let url = 'Info/GetCities';
    return this.get(this.apiUrl+url, {regionId}, true);
  }

  getLicense(functionalID: number, roleId: string): Observable<any[]> {
    let url = 'PortalLicense/GetLicense';
    let res = this.get(this.apiUrl + url, { functionalID, roleId: '002' }, true).pipe(
      map(data => {
        if (data.length > 0) {
          return JSON.parse(data[0].licenseParams);
        } else {
          return data
        }
      })
    );
    return res;
  }

  setLicense(functionalID: number, roleId: string, licenseParams: string) {
    let url = 'PortalLicense/SetLicense';
    return this.post(this.apiUrl + url, { functionalID, roleId: '002', licenseParams: licenseParams}, '',  true);
  }

}

export interface IMioRegion {
  id: number;
  livingComplexCount: number;
  portalID: number;
  name: string;
}

export interface IMioLivingComplex {
  id: number;
  name: string;
  city?: { id: number; name: string }
  spots: IMioSpot[];
}

export interface IMioSpot {
  id: number;
  isSimpleStagesInput: boolean;
  number: string;
}

export interface IMioLicense {
  buildingId: number;
  startDate: any;
  endDate: any;
}